<template>
  <Module :class="tapped ? 'tapped' : 'not-tapped'">
    <v-touch
      :class="'touch'"
      v-on:singletap="tapOne"
      v-on:doubletap="tapTwo"
    >
      <NewsModule v-if="Data.type === 'news'" :Data="Data" :touchState="tapped"/>
      <ArtistModule v-if="Data.type === 'artist'" :Data="Data" :touchState="tapped"/>
      <ReleaseModule v-if="Data.type === 'release'" :Data="Data" :touchState="tapped"/>
    </v-touch>
  </Module>
</template>

<script>
import styled from 'vue-styled-components'
import NewsModule from './NewsModule'
import ArtistModule from './ArtistModule'
import ReleaseModule from './ReleaseModule'
import * as x from '@/styles/mixins'

// STYLES
const Module = styled.li`
  width: 100%;
  height: 100vw;
  position: relative;
  overflow: hidden;
  .touch {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  ${x.media.desktop`
    width: 50%;
    height: 50vh;
  `}
  border-bottom: 1px solid black;
  &:nth-child(odd) {
    .release-title {
      transform: rotate(45deg);
    }
    border-right: 1px solid black;
  }
  &:nth-child(even) {
    .release-title {
      transform: rotate(-45deg);
    }
  }
`

// VUE
export default {
  props: [
    'Data'
  ],
  components: {
    Module,
    NewsModule,
    ReleaseModule,
    ArtistModule
  },
  data () {
    return {
      tapped: false
    }
  },
  methods: {
    tapOne () {
      this.tapped = true
    },
    tapTwo () {
      this.tapped = false
    }
  }
}
</script>
